import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="py-12 px-4 bg-foreground text-background">
      <div className="container mx-auto">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          <div>
            <Link to="/home" className="flex items-center gap-2 mb-4">
              <span className="text-2xl">🐸</span>
              <span className="font-display font-bold text-lg">HabitFrog</span>
            </Link>
            <p className="text-sm opacity-70">
              Transformando vidas através da gamificação de hábitos saudáveis.
            </p>
          </div>
          
          <div>
            <h4 className="font-display font-bold mb-4">Produto</h4>
            <ul className="space-y-2 text-sm opacity-70">
              <li><Link to="/home#como-funciona" className="hover:opacity-100 transition-opacity">Como funciona</Link></li>
              <li><Link to="/precos" className="hover:opacity-100 transition-opacity">Preços</Link></li>
              <li><Link to="/empresas" className="hover:opacity-100 transition-opacity">Para empresas</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-display font-bold mb-4">Recursos</h4>
            <ul className="space-y-2 text-sm opacity-70">
              <li><Link to="/blog/5-tecnicas-para-nunca-mais-procrastinar" className="hover:opacity-100 transition-opacity">Blog</Link></li>
              <li><Link to="/suporte" className="hover:opacity-100 transition-opacity">Suporte</Link></li>
              <li><Link to="/faq" className="hover:opacity-100 transition-opacity">FAQ</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-display font-bold mb-4">Legal</h4>
            <ul className="space-y-2 text-sm opacity-70">
              <li><Link to="/termos-uso" className="hover:opacity-100 transition-opacity">Termos de uso</Link></li>
              <li><Link to="/privacidade" className="hover:opacity-100 transition-opacity">Privacidade</Link></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-background/20 pt-8 text-center text-sm opacity-70">
          <p>© {new Date().getFullYear()} HabitFrog. Todos os direitos reservados.</p>
          <p className="mt-2">
            <a 
              href="https://shinier.com.br" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:opacity-100 underline transition-opacity"
            >
              Startup Acelerada pela Shinier
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
